import { Button } from "@/components/ui/button";
import { ArrowRight, Heart, Bot, MapPin } from "lucide-react";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useLanguage } from "@/contexts/LanguageContext";
import PhoneFrame from "./mockups/PhoneFrame";
import HomeMockup from "./mockups/HomeMockup";

const Hero = () => {
  const { trackEvent } = useAnalytics();
  const { t } = useLanguage();

  const scrollToWaitlist = () => {
    trackEvent('cta_click', { cta_location: 'hero', button_text: 'hero_cta' });
    document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
  };

  const main = t("hero.main");
  const highlight = t("hero.highlight");

  return (
    <section className="relative bg-ink-800 min-h-screen flex items-center overflow-hidden pt-24 pb-12">
      <div className="absolute top-1/3 -left-32 w-[500px] h-[500px] rounded-full bg-violet/15 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-violet-deep/10 blur-[100px] pointer-events-none" />

      <div className="relative z-10 container mx-auto px-6">
        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-center">
          <div className="text-center lg:text-left md:pl-6 lg:pl-12 xl:pl-20">
            <div className="eyebrow mb-6 inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-violet animate-beam-pulse" />
              {t("hero.statusBadge")}
            </div>
            <h2 className="font-display text-white text-5xl md:text-6xl lg:text-7xl leading-[1.0] mb-6">
              {main}{" "}<em className="text-violet italic">{highlight}</em>
            </h2>
            <p className="text-lg md:text-xl text-white/65 leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0">{t("hero.sub")}</p>
            <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start items-center">
              <Button onClick={scrollToWaitlist} className="btn-violet group">
                {t("hero.cta")}
                <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-x-5 gap-y-3">
              {[
                { icon: Heart, label: t("hero.free") },
                { icon: Bot, label: t("hero.ai") },
                { icon: MapPin, label: t("hero.swiss") },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-white/55 text-xs uppercase tracking-[0.14em] font-medium">
                  <item.icon className="h-3.5 w-3.5 text-violet" />
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center lg:justify-end md:pr-6 lg:pr-12 xl:pr-20">
            <div className="relative">
              <div className="absolute -inset-10 bg-violet/20 blur-3xl rounded-full pointer-events-none" />
              <div className="relative">
                <PhoneFrame scale={0.85}>
                  <HomeMockup mode="dark" />
                </PhoneFrame>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
